import React from 'react'
import imageUrl from '../../../utils/imageUrl'

import styles from '../Form.module.css'

const CurrentImage = ({ path, onDelete, disabled }) =>
  <div className={styles.currentImage}>
    <div>Current Image:</div>
    <img src={imageUrl('retailer', path)} alt="Current" />
    {onDelete && (
      <button
        type="button"
        className={`btn btn-danger btn-sm ${styles.deleteImageBtn}`}
        onClick={onDelete}
        disabled={disabled}
      >
        <i className="fa fa-trash" /> Remove
      </button>
    )}
  </div>

export default CurrentImage
